import fetch from 'isomorphic-fetch';

export default function callUrl(url, method = 'get', body) {
    return fetch(`${url}`, {
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({json, response})))
        .then(({json, response}) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            response => response,
            error => error
        );
}
